var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outlined-Bold/Cross-X"
  }, /*#__PURE__*/React.createElement("path", {
    id: "IconVector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.41107 4.41107C4.73651 4.08563 5.26414 4.08563 5.58958 4.41107L10.0003 8.82181L14.4111 4.41107C14.7365 4.08563 15.2641 4.08563 15.5896 4.41107C15.915 4.73651 15.915 5.26414 15.5896 5.58958L11.1788 10.0003L15.5896 14.4111C15.915 14.7365 15.915 15.2641 15.5896 15.5896C15.2641 15.915 14.7365 15.915 14.4111 15.5896L10.0003 11.1788L5.58958 15.5896C5.26414 15.915 4.73651 15.915 4.41107 15.5896C4.08563 15.2641 4.08563 14.7365 4.41107 14.4111L8.82181 10.0003L4.41107 5.58958C4.08563 5.26414 4.08563 4.73651 4.41107 4.41107Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossX);
export default __webpack_public_path__ + "static/media/Cross-X.7d65a30065824c9bb7beed20f08eb512.svg";
export { ForwardRef as ReactComponent };